import ScoreAPI from "../../api/Score";
import BasicNotification from "../../shared/components/Notifications/BasicNotification";

import { scoreTypes } from "../types/score.types";

export const getScoreList = (cb) => async (dispatch) => {
  dispatch({ type: scoreTypes.GET_SCORE_LIST_REQUEST, loading: true });
  try {
    const { body, status } = await ScoreAPI.getScoreList();
    if (cb) cb(body, status);
    dispatch({ type: scoreTypes.GET_SCORE_LIST_SUCCESS, payload: { data: body } });
  } catch (error) {
    if (cb) cb([], 500);
    BasicNotification.error('Error al obtener lista calificaciones.');
    dispatch({ type: scoreTypes.GET_SCORE_LIST_FAILED, payload: { error } });
  }
};

export const resetScoreList = () => (dispatch) => {
  dispatch({ type: scoreTypes.RESET_SCORE_LIST });
};